<template>
  <div class="reconciliationDetail content main-container">
    <div class="baseInfo">
      <div @click="foldBtn(1)" style="margin-bottom: 20px;">
        <Icon :type="fold ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
        <span class="title">基本信息</span>
      </div>
      <Form ref="formValidate" :model="searchParams" :rules="ruleValidate" :label-width="110" class="form" v-show="fold">
        <FormItem label="对账单名称" prop="reconciliationName" :rules="$units.formRule.required('请输入对账单名称')">
          <Input v-model="searchParams.reconciliationName" placeholder="请输入手机号"></Input>
        </FormItem>
        <FormItem label="对账日期" prop="reconciliationDate" :rules="$units.formRule.objRequired('请选择对账日期')">
          <DatePicker transfer v-model="searchParams.reconciliationDate" format="yyyy-MM-dd" type="date" placeholder="请选择"
            disabled>
          </DatePicker>
        </FormItem>
        <FormItem label="供应商类型" prop="supplierType">
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType" >
            <Radio label="" disabled>全部</Radio>
            <Radio label="1" disabled>保险公司</Radio>
            <Radio label="2" disabled>合作通道</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="上游供应商" prop="supplierId" v-if="searchParams.supplierType">
          <Select v-model="searchParams.supplierId" clearable filterable transfer disabled>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="签约协议" prop="agreementId">
          <Select v-model="searchParams.agreementId" clearable placeholder="请选择签约协议" @on-change="changeAgreementType"
            disabled>
            <Option :value="item.id" v-for="(item, index) in agreementList" :key="index">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="签约机构" prop="signOrgName">
          <Input v-model="searchParams.signOrgName" disabled placeholder="选择签约协议显示机构"></Input>
        </FormItem>
        <FormItem label="对账类型" prop="reconciliationName" :rules="$units.formRule.required('请选择对账类型')">
          <Select v-model="searchParams.reconciliationType" clearable disabled>
            <Option value="1">首期费用</Option>
            <Option value="2">首年梯度加费</Option>
            <Option value="3">首期其他费用</Option>
            <Option value="4">续期费用</Option>
            <Option value="5">继续率费用</Option>
            <Option value="6">续期其他费用</Option>
          </Select>
        </FormItem>
        <FormItem label="核收人" prop="reviewer">
          <Input v-model="searchParams.reviewer" placeholder="请输入核收人"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark" class="textarea">
          <Input type="textarea" v-model="searchParams.remark" :autosize="true" placeholder="请输入" clearable />
        </FormItem>
      </Form>
    </div>
    <div class="drawBill" id="drawBill">
      <div class="drawBillbtn">
        <div @click="foldBtn(2)">
          <Icon :type="foldData ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
          <span class="title">开票信息</span>
        </div>
        <div class="titleBtn">
          <span>是否已开票</span>
          <i-Switch v-model="searchParams.billStatus" true-value="1" false-value="0"
            @on-change="changeStatus('billStatus')" :before-change="handleBeforeChange" />
        </div>
      </div>
      <div v-show="foldData">
        <Button type="primary" class="addbtn" @click="editBill()">新增</Button>
        <Table :columns="columns" :data="data" class="table">
          <template slot-scope="{ row }" slot="billType">
            <span>{{ row.billType == 1 ? "普票" : "专票" }}</span>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <div class="detail">
              <div>
                <span style="margin-right: 10px;" @click="editBill(row)">编辑</span>
                <span @click="deleteBill(row)">删除</span>
              </div>
            </div>
          </template>
        </Table>
      </div>
    </div>
    <div class="collectionInformation" id="collectionInformation">
      <div class="drawBillbtn">
        <div @click="foldBtn(3)">
          <Icon :type="collectionfold ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
          <span class="title">回款信息</span>
        </div>
        <div class="titleBtn">
          <span>是否已回款</span>
          <i-Switch v-model="searchParams.returnedStatus" true-value="1" false-value="0"
            @on-change="changeStatus('returnedStatus')" :before-change="handleBeforeChange" />
        </div>
      </div>
      <div v-show="collectionfold">
        <Button type="primary" class="addbtn" @click="editCollection()">新增</Button>
        <Table :columns="collectionColumns" :data="collectionData" class="table">
          <template slot-scope="{ row, index }" slot="action">
            <div class="detail">
              <div>
                <span style="margin-right: 10px;" @click="editCollection(row)">编辑</span>
                <span @click="deleteCollection(row)">删除</span>
              </div>
            </div>
          </template>
        </Table>
      </div>
    </div>
    <div class="collectedPremium" id="collectedPremium" v-if="searchParams.reconciliationType != 4 && searchParams.reconciliationType != 5">
      <div class="drawBillbtn">
        <div @click="foldBtn(4)">
          <Icon :type="payfold ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
          <span class="title">代收保费付款信息</span>
        </div>
        <div class="titleBtn">
          <span>是否已付款</span>
          <i-Switch v-model="searchParams.inwardStatus" true-value="1" false-value="0"
            @on-change="changeStatus('inwardStatus')" :before-change="handleBeforeChange" />
        </div>
      </div>
      <div v-show="payfold">
        <Button type="primary" class="addbtn" @click="editPay()">新增</Button>
        <Table :columns="payColumns" :data="payData" class="table">
          <template slot-scope="{ row, index }" slot="action">
            <div class="detail">
              <div>
                <span style="margin-right: 10px;" @click="editPay(row)">编辑</span>
                <span @click="deletePay(row)">删除</span>
              </div>
            </div>
          </template>
        </Table>
      </div>
    </div>
    <div class="footer">
      <Button type="primary" @click="saveData">保存</Button>
      <Button type="primary" ghost @click="back()">返回</Button>
      <Button type="primary" ghost @click="toPage()">重新对账</Button>
      <Button type="primary" ghost @click="openDetail()">查看对账明细</Button>
      <Button type="primary" ghost @click="daochu()">导出系统数据</Button>
    </div>
    <billModal ref="billModal" @refresh="refresh"></billModal>
    <collectionModal ref="collectionModal" @refresh="refresh"></collectionModal>
    <payModal ref="payModal" @refresh="refresh"></payModal>
    <detailModal ref="detailModal"></detailModal>
  </div>
</template>

<script>
import billModal from "./components/billModal"
import collectionModal from "./components/collectionModal"
import payModal from "./components/payModal"
import detailModal from "./components/detailModal"
import filter from "@/api/filter";
import {common} from "@/api/mixins";
export default {
  mixins:[common],
  components: { billModal, collectionModal, payModal, detailModal },
  data() {
    return {
      fold: true,
      foldData: true,
      collectionfold: true,
      payfold: true,
      isBill: false,
      iscollection: false,
      ispay: false,
      height: 0,
      searchParams: {},
      ruleValidate: {},
      supplierList: [],
      agreementList: [],
      columns: [
        {
          title: "发票类型",
          align: "center",
          slot: "billType",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "发票代码",
          align: "center",
          key: "billCode",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "发票号",
          align: "center",
          key: "billNum",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "发票金额",
          align: "center",
          key: "billAmount",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "开票人",
          align: "center",
          key: "billDrawer",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "开票日期",
          align: "center",
          key: "billDate",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.billDate) {
              const value = filter.filterTime(params.row.billDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 100,
          fixed: "right",
        },
      ],
      data: [],
      collectionData: [],
      payData: [],
      collectionColumns: [
        {
          title: "凭证编号",
          align: "center",
          key: "collectionCode",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "收款日期",
          align: "center",
          key: "collectionDate",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.collectionDate) {
              const value = filter.filterTime(params.row.collectionDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "回款金额",
          align: "center",
          key: "collectionAmount",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "收款账户",
          align: "center",
          key: "collectionAccount",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 100,
          fixed: "right",
        },
      ],
      payColumns: [
        {
          title: "凭证编号",
          align: "center",
          key: "paymentCode",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "付款日期",
          align: "center",
          key: "paymentDate",
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.paymentDate) {
              const value = filter.filterTime(params.row.paymentDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "付款金额",
          align: "center",
          key: "paymentAmount",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "付款账户",
          align: "center",
          key: "paymentAccount",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 100,
          fixed: "right",
        },
      ]
    }
  },
  created() {
    this.detail()
    this.getLists()
    // 根据不同按钮跳转到详情页不同高度，方便用户操作
    this.height = this.$route.query.height
    this.$nextTick(() => {
      // 想要定位的其他位置元素id

      // 开票
      if (this.height == 1) {
        document.getElementById("drawBill").scrollIntoView({ behavior: "smooth", block: 'center' });
      } else if (this.height == 2) {
        // 回款
        document.getElementById("collectionInformation").scrollIntoView({ behavior: "smooth", block: 'center' });
      }
      else if (this.height == 3) {
        //收款
        document.getElementById("collectedPremium").scrollIntoView({ behavior: "smooth", block: 'center' });
      }
    })

  },
  methods: {
    daochu() {
      if(this.$units.pointAction('offline_8_4_5')){
        this.loading = true;
        this.$http({
          url: "/buz/molCommissionConsult/groupPolicy/exportDetailsPageByCheckId",
          type: "POST",
          responseType: "blob",
          data: {
            checkId: this.$route.query.id || this.searchParams.id,
            ...this.searchParams
          },
        })
          .then((res) => {
            this.loading = false;
            this.$units.daochu(res);
          })
          .catch((e) => {
            this.loading = false;
          });
        }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 改变协议类型
    changeAgreementType() {
      if (this.searchParams.agreementId) {
        this.agreementList.forEach((res) => {
          if (res.id == this.searchParams.agreementId) {
            this.searchParams.signOrgName = res.signOrgName
          }
        })
      }else{
        this.searchParams.signOrgName = ''
      }
    },
    getAgreementType() {
      this.$http({
        url: '/buz/covenant/read/list',
        type: 'POST',
        data: {
          pageSize: 1000,
          pageNo: 1,
        }
      }).then((res) => {
        this.agreementList = res.data;
        this.changeAgreementType()
      })
    },
    saveData() {
      if(this.$units.pointAction('offline_8_4_2')){
        if (this.searchParams.reconciliationMonth) {
          this.searchParams.reconciliationMonth = this.$units.formatDate(this.searchParams.reconciliationMonth, "yyyy-MM")
        }
        if(this.searchParams.reconciliationDate){
          this.searchParams.reconciliationDate = this.$units.formatDate(this.searchParams.reconciliationDate, "yyyy-MM-dd")
        }

        this.$http({
          url: "/buz/commissionReconciliation/groupPolicy/edit",
          type: "POST",
          data: this.searchParams,
        }).then((res) => {
          this.$notice.success("保存成功");
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    deletePay(item) {
      if(this.$units.pointAction('offline_8_4_3')){
        this.$notice.inquiry('确认删除操作？').then(async () => {
          this.$http({
            url: `/buz/molCommissionCheckPayment/del`,
            type: "GET",
            data: {
              id: item.id
            }
          }).then((res) => {
            this.$Message.success("删除成功");
            this.refresh();
          })
        })
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 删除回款数据
    deleteCollection(item) {
      if(this.$units.pointAction('offline_8_4_3')){
        this.$notice.inquiry('确认删除操作？').then(async () => {
          this.$http({
            url: `/buz/molCommissionCheckReturnedmoney/del`,
            type: "GET",
            data: {
              id: item.id
            }
          }).then((res) => {
            this.$Message.success("删除成功");
            this.refresh();
          })
        })
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 删除开票数据
    deleteBill(item) {
      if(this.$units.pointAction('offline_8_4_3')){
        this.$notice.inquiry('确认删除操作？').then(async () => {
          this.$http({
            url: `/buz/molCommissionCheckBill/del`,
            type: "GET",
            data: {
              id: item.id
            }
          }).then((res) => {
            this.$Message.success("删除成功");
            this.refresh();
          })
        })
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 更新详情页
    refresh() {
      this.detail()
      this.getLists()
    },
    getLists() {
      // 查询开票列表
      this.$http({
        url: '/buz/molCommissionCheckBill/read/list',
        type: 'POST',
        data: {
          pageNo: "1",
          pageSize: "99",
          checkId: this.$route.query.id || this.searchParams.id
        },
      }).then((res) => {
        this.data = res.data
      })
      // 查询回款列表
      this.$http({
        url: '/buz/molCommissionCheckReturnedmoney/read/list',
        type: 'POST',
        data: {
          pageNo: "1",
          pageSize: "99",
          checkId: this.$route.query.id || this.searchParams.id
        },
      }).then((res) => {
        this.collectionData = res.data
      })
      // 查询付款列表
      this.$http({
        url: '/buz/molCommissionCheckPayment/read/list',
        type: 'POST',
        data: {
          pageNo: "1",
          pageSize: "99",
          checkId: this.$route.query.id || this.searchParams.id
        },
      }).then((res) => {
        this.payData = res.data
      })
    },
    editPay(row){
      if(this.$units.pointAction('offline_8_4_3')){
          this.$refs.payModal.open(row)
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    editCollection(row){
      if(this.$units.pointAction('offline_8_4_3')){
          this.$refs.collectionModal.open(row)
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    editBill(row){
      if(this.$units.pointAction('offline_8_4_3')){
          this.$refs.billModal.open(row)
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    handleBeforeChange(){
      return new Promise((resolve) => {
        if(this.$units.pointAction('offline_8_2_3')){
          resolve();
        }else{
          this.$Message.error('无权操作，请联系您的上级')
        }
      });
    },
    changeStatus(val) {
        let data = {}
        if (val == 'billStatus') {
          data = {
            billStatus: this.searchParams.billStatus,
            id: this.$route.query.id
          }
        } else if (val == 'returnedStatus') {
          data = {
            returnedStatus: this.searchParams.returnedStatus,
            id: this.$route.query.id
          }
        } else if (val == 'inwardStatus') {
          data = {
            inwardStatus: this.searchParams.inwardStatus,
            id: this.$route.query.id
          }
        }
        this.$http({
          url: '/buz/commissionReconciliation/edit',
          type: 'POST',
          data: data,
        }).then(() => {
          this.$notice.success("更改成功");
        })
      
    },
    detail() {
      this.$http({
        url: "/buz/commissionReconciliation/read/detail",
        type: "GET",
        data: { id: this.$route.query.id },
      }).then((res) => {
        this.searchParams = res.data
        this.searchParams.reconciliationDate = res.data.reconciliationDate ? filter.filterTime(res.data.reconciliationDate, "YYYY-MM-DD") : ''
        this.setPageTitle(this.searchParams.reconciliationName)
        this.getAgreementType()
        this.changeSupplierType(this.searchParams.supplierType)
      });
    },
    openDetail(){
      if(this.$units.pointAction('offline_8_4_1')){
        this.$refs.detailModal.open(this.searchParams)
      }else{
          this.$Message.error('无权操作，请联系您的上级')
        }
    },
    // 跳转对账单页面
    toPage() {
      if(this.$units.pointAction('offline_8_4_4')){
        this.$notice.inquiry("是否重置全部流程重新开始对账？").then(async () => {
          this.$http({
            url: '/buz/commissionReconciliation/jumpBack',
            type: 'POST',
            data: {
              id: this.searchParams.id
            },
          }).then((res) => {
            this.$router.push({
              path: "/offline/getAccounts/detail",
              query: { id: this.searchParams.id }
            })
          })
        }).catch((res) => {
          console.log(res);
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
    },
    // 展开收起
    foldBtn(val) {
      if (val == 1) {
        this.fold = !this.fold
      } else if (val == 2) {
        this.foldData = !this.foldData
      } else if (val == 3) {
        this.collectionfold = !this.collectionfold
      } else if (val == 4) {
        this.payfold = !this.payfold
      }

    }
  }
}
</script>

<style lang="scss" scoped>
@import "./detail.scss";
</style>